export const GAViewItem = (product) => {
  const itemCategory2 = product.metal ? { item_category2: product.metal } : {}
  const itemCategory3 = product.metal_color ? { item_category3: product.metal_color } : {}
  const itemCategory4 = product.product_collection ? { item_category4: product.product_collection } : {}
  const dataLayer = window.dataLayer || []
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "view_item",
    ecommerce: {
      items: [
        {
          item_name: product.name,
          item_id: product.code_parent,
          price: product.current, // Number
          item_brand: "Укрзолото",
          item_category: product.category,
          item_variant: `${product.properties.size.name} - ${product.properties.size.title}`,
          ...itemCategory2,
          ...itemCategory3,
          ...itemCategory4,
        },
      ],
    },
  })
}
